module.exports = __webpack_public_path__ + "img/markBGI3.47f12f99.png";